import { render, staticRenderFns } from "./campaign-base-info.vue?vue&type=template&id=758a2ea5&scoped=true&"
import script from "./campaign-base-info.vue?vue&type=script&lang=js&"
export * from "./campaign-base-info.vue?vue&type=script&lang=js&"
import style0 from "./campaign-base-info.vue?vue&type=style&index=0&id=758a2ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758a2ea5",
  null
  
)

export default component.exports